export default __webpack_public_path__ + "static/media/goal.22caa039.svg";